import { Question2 } from "@dsm/dsm-storybook";

export const headerInformation = {
  title: "headerInformation.title",
  shortText: "headerInformation.shortText",
  longText: "headerInformation.longText",

}

export const reportIntroductionInfo = {
  title: "reportIntroductionInfo.title",
  description: "reportIntroductionInfo.description",
  disclaimer: "reportIntroductionInfo.disclaimer",
  buttons: [
    {
      label: "reportIntroductionInfo.contactButton",
      link: "https://www.envalior.com/en-us/contact-us.html",
      target: "_blank"
    },
    {
      label: "reportIntroductionInfo.continueButtons"
    }
  ]
};

export const disclaimer = {
  title: "disclaimer.title",
  shortDescription: "disclaimer.short_description",
  longDescription: "disclaimer.long_description"
};

export const rootCausesInformation = {
  contact: {
    linkURL: "https://www.envalior.com/en-us/contact-us.html",
    target: "_blank",
    text: "rootCausesInformation.contactText"
  },
  description: "rootCausesInformation.description",
  mitigations: [

  ],
  insights: [
    {
      title: "rootCausesInformation.systemDesign",
      linkURL: "https://www.envalior.com/en-us/services/system-design.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.partCompliance",
      linkURL: "https://www.envalior.com/en-us/services/part-compliance.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.CAEServices",
      linkURL: "https://www.envalior.com/en-us/services/cae-services.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.partPrototyping",
      linkURL: "https://www.envalior.com/en-us/services/part-prototyping.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.materialProcessing",
      linkURL: "https://www.envalior.com/en-us/services/material-processing.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.partProduction",
      linkURL: "https://www.envalior.com/en-us/services/part-production.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.postProcessingOptimization",
      linkURL: "https://www.envalior.com/en-us/services/post-processing-optimization.html",
      icon: ""
    },
    {
      title: "rootCausesInformation.sustainableSolutions",
      linkURL: "https://www.envalior.com/en-us/services/sustainable-solutions.html",
      icon: ""
    },
  ]
}

export const defaultQuestions = [
  {
    id: "question-1",
    questionNumber: "1",
    type: 'question-view',
    i18nQuestion: "In which stage is your project?",
    i18nShortQuestion: "",
    i18nXsQuestion: "",
    refine: false,
    isActive: true,
    parent: null,
    answers: [
      {
        id: "question-1-answer-1",
        value: "1.1",
        i18nDescription: "I am at the start of a project, and want to improve my awareness of potential failures",
        i18nDescriptionText: "",
        imgUrl: "/assets/questions/looking-to-prevent-issues.jpg",
        isSelected: false,
        subQuestions: [],
      },
      {
        id: "question-1-answer-2",
        value: "1.2",
        i18nDescription: "In my project, issues are occurring. I am looking for specific solutions.",
        i18nDescriptionText: "",
        imgUrl: "/assets/questions/running-into-an-issue.jpg",
        isSelected: false,
        subQuestions: [],
      }
    ],
  } as Question2,
  {
    id: "question-2",
    questionNumber: "2",
    type: 'question-view',
    i18nQuestion: 'What type of failure category applies to your situation?',
    refine: false,
    isActive: false,
    parent: null,
    answers: [],
  } as Question2,
  {
    id: "question-3",
    questionNumber: "3",
    type: 'question-view',
    i18nQuestion: "In which phase of the product development and production process most likely lies the origin of the failure?",
    i18nShortQuestion: "",
    i18nXsQuestion: "",
    refine: false,
    isActive: true,
    parent: null,
    answers: [],
  } as Question2,
  {
    id: "root-cause",
    questionNumber: "4",
    type: 'root-cause',
    index: 1,
    i18nQuestion: "In case of >3 potential root causes displayed, please select max. 3 potential root causes that you want to learn more about",
    i18nShortQuestion: "",
    i18nXsQuestion: "",
    refine: false,
    isActive: true,
    parent: null,
    answers: []
  },
  {
    id: "risk-analysis",
    questionNumber: "5",
    type: 'risk-analysis',
    i18nQuestion: "Failure mode risk assessment",
    i18nShortQuestion: "",
    i18nXsQuestion: "",
    refine: false,
    isActive: false,
    parent: null,
    answers: []
  } as Question2,
  {
    id: "report",
    questionNumber: "6",
    type: 'report',
    i18nQuestion: "Your personal report",
    i18nShortQuestion: "",
    i18nXsQuestion: "",
    refine: false,
    isActive: false,
    parent: null,
    answers: []
  } as Question2
];
